import styled from 'styled-components';
import { getSpace, mq, maxContentWidth } from '../../../stylesheets/tools';

const StyledHighlightStage = styled.section`
  .highlight-stage__inner-content {
    ${maxContentWidth('1440px')}
    position: relative;

    ${mq('m')} {
      margin-top: ${getSpace('xxxl')};
      padding-top: ${getSpace('xxxl')};
    }
  }

  .highlight-stage__wrapper {
    h3,
    h1,
    .highlight-stage__introduction {
      margin-right: auto;
      display: block;
      margin-left: 0;

      ${mq('m')} {
        max-width: 422px;
      }
    }
    .highlight-stage__introduction {
      margin-top: ${getSpace('s')};

      ${mq('m')} {
        margin-top: ${getSpace('m')};
      }
    }

    h3 {
      ${mq('m')} {
        margin-bottom: ${getSpace('s')};
      }
    }
  }

  .highlight-stage__image {
    position: relative;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10vw;

    ${mq('m')} {
      margin-bottom: 20vw;
      position: absolute;
      top: 0;
      right: 0;
      margin-bottom: 0;
    }

    .highlight-stage__image-underlay {
      position: absolute;
      top: 0;
      right: 0;
      width: 93vw;
      height: 100%;

      ${mq('m')} {
        width: 100%;
      }
    }

    .highlight-stage__credits {
      position: absolute;
      bottom: -1.5rem;
      right: ${getSpace('s')};
      width: 35%;
      height: 1.5rem;
      transform: rotate(-15deg);
      z-index: 1;

      &::before {
        content: '';
        display: inline-block;
        float: right;
        shape-outside: polygon(0 0, 80% 20%, 100% 60%, 50% 100%, 100% 100%, 100% 0%);
      }

      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &-mask-overlay {
      position: absolute;
      top: 0;
      right: 0;
      width: calc(100% - 10px);
      height: 100%;
      transform: translateY(30px);
      z-index: -1;
    }

    img {
      width: 93vw;
      max-height: min(900px, 100vh);
      mask-image: url('/static/dots/guided-background.svg');
      mask-size: contain;
      mask-repeat: no-repeat;
      mask-position: top right;

      ${mq('m')} {
        width: 100%;
        max-width: 50vw;
      }
    }
  }
`;

export default StyledHighlightStage;
